import { ADD_MEMBER_ACTION_TYPES } from '../../../constants/actionTypes/addMemborActionTypes';

export const INITIAL_STATE = {};

interface AddMemberAction {
    type: string;
    payload?: any;
}

// Reducer function with typed state and action
export default (state = INITIAL_STATE, action: AddMemberAction) => {
    switch (action?.type) {
        case ADD_MEMBER_ACTION_TYPES.GET_SSN_DETAILS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
};
